import * as React from 'react';
import Button from '../../../components/Button';
import styled from '../../../styled-components';

interface AddCandidateFormProps {
    onAdd: (firstname: string, lastname: string, email: string) => void;
}

interface AddCandidateFormState {
    showInvitationSentNotification: boolean;
}

const Layout = styled.div`
    input,
    ${Button} {
        display: block;
        margin-bottom: 0.5em;
    }
`;

class AddCandidateForm extends React.Component<AddCandidateFormProps, AddCandidateFormState> {
    private firstnameRef: React.RefObject<HTMLInputElement>;
    private lastnameRef: React.RefObject<HTMLInputElement>;
    private emailRef: React.RefObject<HTMLInputElement>;

    constructor(props: AddCandidateFormProps) {
        super(props);
        this.firstnameRef = React.createRef();
        this.lastnameRef = React.createRef();
        this.emailRef = React.createRef();
        this.handleAddCandidate = this.handleAddCandidate.bind(this);
    }

    private handleAddCandidate() {
        const firstname = this.firstnameRef.current;
        const lastname = this.lastnameRef.current;
        const email = this.emailRef.current;
        if (firstname && firstname.value.length && lastname && lastname.value.length && email && email.value.length) {
            this.props.onAdd(firstname.value, lastname.value, email.value);
        }
    }

    public render() {
        return (
            <Layout>
                <input name="firstname" ref={this.firstnameRef} placeholder="Firstname" />
                <input name="lastname" ref={this.lastnameRef} placeholder="Lastname" />
                <input name="email" ref={this.emailRef} placeholder="E-Mail" />
                <Button onClick={this.handleAddCandidate}>Add candidate</Button>
            </Layout>
        );
    }
}

export default AddCandidateForm;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/AddCandidateForm.tsx